import React from "react";
import { useTranslation } from "react-i18next";
import { FilterOutlined } from "@ant-design/icons";

import {
  Card,
  CardTitle,
  CardCaption,
  FunnelRow,
  FunnelHead,
  FunnelLabel,
  FunnelMeta,
  FunnelTrack,
  FunnelFill,
  DropOff
} from "./dashboardStyles";
import { FUNNEL_STAGES, percent } from "./dashboardHelpers";

/**
 * The run funnel — distinct runs that REACHED each of the 7 pipeline stages
 * (step presence), so it only ever narrows down the page. Each bar's width is
 * the stage's share of `Started` (the first stage = 100%); the right-hand meta
 * shows the absolute count + that share, and a per-stage drop-off note shows
 * how many runs fell out since the previous stage. Range-scoped.
 */
const DashboardFunnel = ({ stats }) => {
  const { t } = useTranslation();

  const funnel = stats?.funnel ?? {};
  const started = funnel.started ?? 0;

  return (
    <Card data-testid="agentic-dashboard-funnel">
      <CardTitle>
        <FilterOutlined />
        {t("agentic_dashboard.funnel.title")}
      </CardTitle>
      <CardCaption>{t("agentic_dashboard.funnel.caption")}</CardCaption>

      {FUNNEL_STAGES.map((stage, idx) => {
        const count = funnel[stage.key] ?? 0;
        const pct = percent(count, started);
        const prevCount = idx === 0 ? count : funnel[FUNNEL_STAGES[idx - 1].key] ?? 0;
        const dropped = Math.max(0, prevCount - count);

        return (
          <FunnelRow key={stage.key} data-testid={`agentic-dashboard-funnel-${stage.key}`}>
            <FunnelHead>
              <FunnelLabel>{t(stage.labelKey)}</FunnelLabel>
              <FunnelMeta>
                <b>{count.toLocaleString()}</b> · {pct}%
              </FunnelMeta>
            </FunnelHead>
            <FunnelTrack>
              <FunnelFill $pct={pct} />
            </FunnelTrack>
            {idx > 0 && dropped > 0 && <DropOff>{t("agentic_dashboard.funnel.dropped", { count: dropped })}</DropOff>}
          </FunnelRow>
        );
      })}
    </Card>
  );
};

export { DashboardFunnel };
